<div class="theme-main-menu sticky-menu theme-menu-three" [ngClass]="headerSticky ? 'fixed' : ''">
  <div class="d-flex align-items-center justify-content-center">
    <div class="logo"><a [routerLink]="['/']">
      <img src="assets/images/logo/deski_01.svg" alt=""></a>
   </div>

    <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
      <div  class="nav-container">
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
            [ngClass]="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" (click)="handleNavToggle()">
            <span></span>
        </button>
         <div class="navbar-collapse collapse" id="collapsibleNavbar">
             <div class="d-lg-flex justify-content-between align-items-center">
                <!-- nav menu start -->
                <app-nav-menu></app-nav-menu>
                <!-- nav menu end -->

            <ul class="right-widget user-login-button d-flex align-items-center justify-content-center">
              <li>
                <a [routerLink]="['/login']" class="signIn-action d-flex align-items-center">
                  <img src="assets/images/icon/52.svg" alt="">
                  <span>Login</span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/register']" class="signUp-action d-flex align-items-center">
                  <span>Getting Started</span>
                  <img src="assets/images/icon/53.svg" alt="">
                </a>
              </li>
            </ul>
             </div>
           </div>
      </div>
    </nav>
  </div>
</div>
